import React from 'react';
import { useScope } from '../../contexts/ScopeContext';
import { useShellOwns } from '../../chrome/ShellChromeContext';
import {useLocation} from 'react-router-dom';
import {scopePresentation} from '../../scope/presentation';
export interface ScopeRibbonProps { shell?: boolean }
export const ScopeRibbon: React.FC<ScopeRibbonProps> = ({ shell = false }) => {
  const superseded = useShellOwns('scopeRibbon', shell); const scope = useScope();
  const presentation=scopePresentation(useLocation().pathname);
  if (superseded) return null;
  return <div role="region" aria-label="Scope" data-testid="scope-ribbon" className="flex flex-wrap items-center gap-3 px-4 py-2 border-b bg-white text-sm">
    <span className="text-gray-500">Scope</span>
    <span data-testid={presentation.kind!=='environment'?'scope-ribbon-fixed':scope.resolved.kind === 'all' ? 'scope-ribbon-all-environments' : 'scope-ribbon-environment'}>{presentation.kind==='environment'?scope.label:presentation.label}{presentation.kind==='environment'&&scope.resolved.kind === 'all' ? ' · read-only' : ''}</span>
    {presentation.reason&&<span>{presentation.reason} Browsing scope retained: {scope.label}.</span>}
    {presentation.kind==='environment'&&scope.resolved.kind === 'blocked' && <span role="status">Select an available registered environment. No default target is used.</span>}
    {presentation.kind==='environment'&&scope.portalId && <span>Portal {scope.portalId}</span>}
  </div>;
};
export default ScopeRibbon;
